import React, { useState } from 'react';
import { MessageCircleIcon, MapPinIcon, ClockIcon, InstagramIcon, CheckCircle2Icon, Loader2Icon, ExternalLinkIcon } from 'lucide-react';
import { CONTACT_INFO } from '../data/site';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
type Status = 'idle' | 'sending' | 'sent' | 'error';
const inputClass = 'w-full rounded-2xl border border-black/10 bg-white px-5 py-4 text-base text-ink placeholder:text-ink-muted transition-colors duration-200 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    nombre: '',
    correo: '',
    telefono: '',
    mensaje: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(prev => ({
    ...prev,
    [e.target.name]: e.target.value
  }));
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.nombre || !form.correo || !form.mensaje) {
      setStatus('error');
      return;
    }
    setStatus('sending');
    window.setTimeout(() => {
      setStatus('sent');
      setForm({
        nombre: '',
        correo: '',
        telefono: '',
        mensaje: ''
      });
    }, 1200);
  };
  return <section id="contacto" className="bg-white py-24 sm:py-32 lg:py-40" data-id="element-46" data-mp="3f4milfzsfqgk">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-47" data-mp="3f2i46449j921">
        <Reveal data-id="element-48" data-mp="31421co9iu2p6">
          <SectionHeading eyebrow="Contacto" title="Hablemos de tu hogar." description="Escribinos o pasá por el local. Te respondemos con una propuesta pensada para vos, sin apuros." data-id="element-49" data-mp="313ihv3483691" />
        </Reveal>

        <div className="mt-14 grid gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-50" data-mp="2w5qmfz4dd203">
          <Reveal data-id="element-51" data-mp="2w836qixlnogb">
            <div className="relative overflow-hidden rounded-4xl border border-black/5 shadow-soft h-[380px] sm:h-[480px] lg:h-full lg:min-h-[560px]" data-id="element-52" data-mp="qd21nw9bxn91">
              <iframe title="Ubicación de Silver Hogar en Almirante Brown 2535, Chajarí" src={CONTACT_INFO.mapEmbedUrl} className="h-full w-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-53" data-mp="ue3u9u8qr121" />
              <a href={CONTACT_INFO.mapLinkUrl} target="_blank" rel="noreferrer" className="absolute bottom-5 left-5 right-5 inline-flex items-center justify-between gap-4 rounded-2xl bg-white/95 px-5 py-4 shadow-float backdrop-blur-md transition-colors duration-300 hover:bg-white sm:right-auto" data-id="element-54" data-mp="1ub5ududaa465">
                <span className="flex items-center gap-3" data-id="element-55" data-mp="2d8gqx77j6jhw">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-brand-light text-brand" data-id="element-56" data-mp="28ax0za1h0ia4">
                    <MapPinIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-57" data-mp="35qb0z9gjcmv1" />
                  </span>
                  <span className="flex flex-col" data-id="element-58" data-mp="30ykjmjj6kyu4">
                    <span className="text-sm font-medium text-ink" data-id="element-59" data-mp="38ah3rdtey7a0">{CONTACT_INFO.address}</span>
                    <span className="text-xs text-ink-muted" data-id="element-60" data-mp="3d9k8ex5hebhg">Ver en Google Maps</span>
                  </span>
                </span>
                <ExternalLinkIcon className="h-4 w-4 shrink-0 text-ink-muted" strokeWidth={1.5} aria-hidden="true" data-id="element-61" data-mp="3i8ex2fq4qu9h" />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15} data-id="element-62" data-mp="3r9358tsue0eg">
            <form onSubmit={handleSubmit} noValidate className="rounded-4xl border border-black/5 bg-haze p-7 sm:p-10 shadow-soft" data-id="element-63" data-mp="2s7p7n1jhrv">
              <div className="grid gap-5 sm:grid-cols-2" data-id="element-64" data-mp="9sva1yg1y82v">
                <div className="sm:col-span-2" data-id="element-65" data-mp="9sbsiiubdlpd">
                  <label htmlFor="nombre" className="mb-2 block text-sm font-medium text-ink" data-id="element-66" data-mp="duq9syic4dej">
                    Nombre
                  </label>
                  <input id="nombre" name="nombre" type="text" required value={form.nombre} onChange={handleChange} placeholder="Tu nombre completo" className={inputClass} data-id="element-67" data-mp="iu2vvh1dtgg2" />
                </div>
                <div data-id="element-68" data-mp="9x9fwzh3ssj6">
                  <label htmlFor="correo" className="mb-2 block text-sm font-medium text-ink" data-id="element-69" data-mp="9yuceumzaljo">
                    Correo
                  </label>
                  <input id="correo" name="correo" type="email" required value={form.correo} onChange={handleChange} placeholder="nombre@correo.com" className={inputClass} data-id="element-70" data-mp="3ebr5n5gtrcqg" />
                </div>
                <div data-id="element-71" data-mp="17ne5z1ngjoil">
                  <label htmlFor="telefono" className="mb-2 block text-sm font-medium text-ink" data-id="element-72" data-mp="12m6w8x1r8f9a">
                    Teléfono
                  </label>
                  <input id="telefono" name="telefono" type="tel" value={form.telefono} onChange={handleChange} placeholder="+54 9 11 0000-0000" className={inputClass} data-id="element-73" data-mp="2kj1tbpurr3hc" />
                </div>
                <div className="sm:col-span-2" data-id="element-74" data-mp="347swk2nmvs8t">
                  <label htmlFor="mensaje" className="mb-2 block text-sm font-medium text-ink" data-id="element-75" data-mp="3493z5z5cetyc">
                    Mensaje
                  </label>
                  <textarea id="mensaje" name="mensaje" required rows={5} value={form.mensaje} onChange={handleChange} placeholder="Contanos qué estás buscando para tu hogar" className={`${inputClass} resize-none`} data-id="element-76" data-mp="2ui99eksw1c85" />
                </div>
              </div>

              <div aria-live="polite" className="mt-5 min-h-[24px]" data-id="element-77" data-mp="5my7jqc3ai9w">
                {status === 'error' && <p className="text-sm text-brand-dark" data-id="element-78" data-mp="pfvvs6otoy7">
                    Completá nombre, correo y mensaje para poder responderte.
                  </p>}
                {status === 'sent' && <p className="flex items-center gap-2 text-sm text-ink" data-id="element-79" data-mp="3mvuu3seql4bk">
                    <CheckCircle2Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-80" data-mp="3ivb0gytdgiu6" />
                    ¡Gracias! Te vamos a contactar a la brevedad.
                  </p>}
              </div>

              <button type="submit" disabled={status === 'sending'} className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-8 py-4 text-base font-medium text-white transition-all duration-300 hover:bg-brand-dark hover:shadow-float disabled:opacity-70 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-81" data-mp="394zl8g48mn7z">
                {status === 'sending' && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-82" data-mp="1emwu2p1cleb6" />}
                {status === 'sending' ? 'Enviando…' : 'Enviar mensaje'}
              </button>
            </form>
          </Reveal>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-83" data-mp="qz6uhg0ti13v">
          {[{
          icon: <MessageCircleIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-84" data-mp="vxgq1rqgf3q0" />,
          label: 'WhatsApp',
          value: CONTACT_INFO.whatsapp,
          href: CONTACT_INFO.whatsappUrl
        }, {
          icon: <MapPinIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-85" data-mp="15ol50rg4qoku" />,
          label: 'Dirección',
          value: CONTACT_INFO.address,
          href: CONTACT_INFO.mapLinkUrl
        }, {
          icon: <ClockIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-86" data-mp="d5fjs4bcob6k" />,
          label: 'Horario',
          value: CONTACT_INFO.hoursShort
        }, {
          icon: <InstagramIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-87" data-mp="2xs24wguq83eh" />,
          label: 'Instagram',
          value: CONTACT_INFO.instagram,
          href: CONTACT_INFO.instagramUrl
        }].map(item => {
          const content = <>
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light text-brand" data-id="element-88" data-mp="3ln567oapvzbu">
                  {item.icon}
                </span>
                <span className="mt-4 block text-xs uppercase tracking-[0.16em] text-ink-muted" data-id="element-89" data-mp="3uh9qfovcicie">
                  {item.label}
                </span>
                <span className="mt-1 block text-sm font-medium leading-snug text-ink" data-id="element-90" data-mp="3qfy7g26z8pj6">
                  {item.value}
                </span>
              </>;
          return item.href ? <a key={item.label} href={item.href} target="_blank" rel="noreferrer" className="rounded-3xl border border-black/5 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-float" data-id="element-91" data-mp="38cfvnjvwm67">
                {content}
              </a> : <div key={item.label} className="rounded-3xl border border-black/5 bg-white p-6 shadow-soft" data-id="element-92" data-mp="hvkuyzgbdbng">
                {content}
              </div>;
        })}
        </div>

        <div className="mt-6 flex items-center gap-3" data-id="element-93" data-mp="3qcz95cs9am6l">
          <a href={CONTACT_INFO.instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram de Silver Hogar" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 text-ink-soft transition-colors hover:border-brand hover:bg-brand hover:text-white" data-id="element-94" data-mp="3qeip12a02v7u">
            <InstagramIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-95" data-mp="3iptelun8h7bc" />
          </a>
        </div>
      </div>
    </section>;
}